/**
 * Mapping TypeClientele (public / typesClientele) → icône par enumKey (prioritaire) ou id (fallback).
 * Icône par défaut : bold/essentional_ui/info_circle.
 */

/** Type clientèle (id + enumKey optionnel) pour la résolution d'icône */
export type TypeClienteleRef = { id: number; enumKey?: string };

const DEFAULT_TYPE_CLIENTELE_ICON = "bold/essentional_ui/info_circle";

/** enumKey (TypeClientele) → icône */
const ENUM_KEY_TO_ICON: Record<string, string> = {
  TYPE_CLIENTELE_ENFANTS: "bold/essentional_ui/family", // Spécial famille avec enfants
  TYPE_CLIENTELE_GROUPES: "bold/users/users_group_two_rounded", // Accueil groupes
  TYPE_CLIENTELE_FERME_CLIENTELE_EXTERIEURE: "bold/essentional_ui/info_circle",
};

/** id (TypeClientele) → icône */
const ID_TO_ICON: Record<number, string> = {
  513: "bold/essentional_ui/family", // Spécial famille avec enfants
  593: "bold/users/users_group_two_rounded", // Accueil groupes
  558: "bold/sports/hiking_round", // Randonneurs
  594: "bold/home_furniture/child_hat", // Spécial enfants
  512: "bold/sports/bicycling_round", // Cyclistes
  3735: "bold/essentional_ui/info_circle", // Adapté aux débutants
  596: "bold/school/square_academic_cap", // Accueil de groupes scolaires
  563: "bold/sports/bicycling_round", // VTTistes
  588: "bold/essentional_ui/info_circle", // Niveau bleu - Modéré
  597: "bold/school/case_minimalistic", // Accueil groupes affaire/incentive
  496: "bold/users/user", // Spécial adolescents
  565: "bold/transport_parts_service/two_wheeler", // Motards
  587: "bold/essentional_ui/info_circle", // Niveau vert - Facile
  589: "bold/essentional_ui/info_circle", // Niveau rouge - Difficile
  509: "bold/like/heart", // Spécial amoureux
  4547: "bold/transport_parts_service/bus", // Accueil de colonies de vacances
};

/**
 * Retourne l'icône pour un type de clientèle : enumKey en priorité, puis id en fallback.
 */
export function getTypeClienteleIconName(
  type: TypeClienteleRef | undefined,
): string {
  if (!type) return DEFAULT_TYPE_CLIENTELE_ICON;
  const enumKey = type.enumKey?.trim() ?? "";
  if (enumKey && ENUM_KEY_TO_ICON[enumKey]) {
    return ENUM_KEY_TO_ICON[enumKey];
  }
  const id = typeof type.id === "number" ? type.id : undefined;
  if (id !== undefined && ID_TO_ICON[id] !== undefined) {
    return ID_TO_ICON[id];
  }
  return DEFAULT_TYPE_CLIENTELE_ICON;
}
